const THREE = require('three')
import raf from '../raf'
import {state} from '../main'
import config from '../config'
import {TweenMax, Cubic} from 'gsap'

// console.log(appConfig)
// console.log(config)

export default class SpeedLines {

  constructor (config) {
    this.mesh = new THREE.Object3D()
    this.mesh.name = 'VelocityEffectShaders'

    this.state = Object.assign({
      lines: 100,
      time: 0
    }, config)

    const s = 0.1
    this.mesh.scale.set(s, s, s)
    this.mesh.position.x = 7
    this.mesh.position.y = 8
    this.mesh.position.z = 17

    this.opacity = 1

    this.lines = []

    this.initShaders()
    this.initLinesGeometry()

  }

  NbRand(min, max) {
    return Math.random() * max + min
  }

  initShaders() {
    this.vertexShader = require('../shaders/speed-effect.vs')
    this.fragmentShader = require('../shaders/speed-effect.fs')
  }

  initLinesGeometry() {
    let geometry = new THREE.BoxGeometry(100, 0.3, 0.01)
    let bufferGeometry = new THREE.BufferGeometry().fromGeometry( geometry )

    for ( let i = 0; i < this.state.lines; i++) {

      let shaderMaterial = new THREE.RawShaderMaterial({
        vertexShader: this.vertexShader,
        fragmentShader: this.fragmentShader,
        transparent: true,
        uniforms: {
          time: { type: 'f', value: 0 },
          ypos: { type: 'f', value: this.NbRand(-10, 10) },
          velocity: { type: 'f', value: this.NbRand(0, 10) },
          velocityMax: { type: 'f', value: config.velocityMax },
          opacity: { type: 'f', value: 0 }
        },
        depthTest:false,
        depthWrite: false
      })


      this.lines[i] = new THREE.Mesh(bufferGeometry, shaderMaterial)
      this.lines[i].rotation.y = Math.PI / 2

      this.lines[i].position.y += this.NbRand(0, -100)
      this.lines[i].position.z += this.NbRand(0, -100)
      this.lines[i].position.x += this.NbRand(0, -100)

      // this.lines[i].material = material
      this.mesh.add(this.lines[i])
    }
  }

  update = (delta = 1)=> {
    for ( var i = 0; i < this.state.lines; i++) {
      this.lines[i].material.uniforms.time.value += delta / (1000 / 60)
      this.lines[i].material.uniforms.velocity.value = state.velocity.now
      this.lines[i].material.uniforms.opacity.value = this.opacity
    }
  }

  enable(time = 1) {
    TweenMax.to(this, time, {
      opacity: 1,
      ease: Cubic.easeIn
    })
  }

  disable(time = 1) {
    TweenMax.to(this, time, {
      opacity: 0,
      ease: Cubic.easeIn
    })
  }
}




// WEBPACK FOOTER //
// ./src/components/game/effects/speedLines.js